import BaseService from "../BaseService";
import { API_BASE_URL_ENV } from "helpers/common";
import http from "../HttpService";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/crm/deals";  
const apiFeedBackEndPoint=API_BASE_URL_ENV() + "/admin/crm/feedbacks"; 
const apiFeedBackBulkEndPoint=API_BASE_URL_ENV() + "/admin/crm/feedbacks-bulk-create"; 
const apiSubmitReceiptEndPoint= API_BASE_URL_ENV()+ '/crm/deal-reciept/6/Submit'
const apiNotSubmitReceiptEndPoint= API_BASE_URL_ENV()+ '/crm/deal-reciept/6/Not-Submit'
const apiUpdateMultiEndPoint= API_BASE_URL_ENV()+ '/admin/crm/deals-bulk-update'
const apiDeleteMultiEndPoint= API_BASE_URL_ENV()+ '/admin/crm/deals-bulk-delete'
 

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }
 
    addFeedback=(data)=>{
        return http.post(apiFeedBackEndPoint, data);
    }

    addFeedbackBulk=(data)=>{
        return http.post(apiFeedBackBulkEndPoint, data);
    }

    updateMultiDeals=(data)=>{
        return http.post(apiUpdateMultiEndPoint, data);
    }

    removeMulti=(data)=>{
        return http.delete(apiDeleteMultiEndPoint, {data});
    }

    submitRecepit = (id) =>{
        const url = API_BASE_URL_ENV()+ `/admin/crm/deal-reciept/${id}/Submit`
        return http.get(url);
    }
    notSubmitRecepit = (id) =>{
        const url = API_BASE_URL_ENV()+ `/admin/crm/deal-reciept/${id}/Not-Submit`
        return http.get(url);
    }
    sendMessage= (data) => {
        const url = API_BASE_URL_ENV()+ `/crm/send-message`
        return http.post(url, data);
    }
    bulkSendMessage= (data) => {
        const url = API_BASE_URL_ENV()+ `/crm/bulk-send-messages`
        return http.post(url, data);
    }
}
